export class InitialsUtils {
  static getInitials(name: string | null | undefined): string {
    if (!name) return '--';

    const words = name.trim().split(' ').filter(w => w.length > 0);

    if (words.length === 0) return '--';
    if (words.length === 1) return words[0][0].toUpperCase();

    return (words[0][0] + words[1][0]).toUpperCase();
  }
}
